import React from "react";

// https://reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
export const useForceUpdate = () => {
  const [, setValue] = React.useState(0); // integer state
  return () => setValue((value) => value + 1); // update the state to force render
};
